import client from '../../base-api';

const serviceURL = '/unemployed/assisted-living-coaching';

const assistedLivingCoachingService = {
    getAssistedLivingCoachingList(unemployedId: number) {
        return client.get(`${serviceURL}/${unemployedId}`);
    },
    getAssistedLivingCoaching(id: number) {
        return client.get(`${serviceURL}/details/${id}`);
    },
    postAssistedLivingCoaching(coachingData: any) {
        return client.post(`${serviceURL}`, coachingData);
    },
    putAssistedLivingCoaching(coachingData: any, coachingId: number) {
        return client.put(`${serviceURL}/${coachingId}`, coachingData);
    },
    assistedLivingCoachingTermination(terminationData: any, coachingId: number) {
        return client.put(`${serviceURL}/termination/${coachingId}`, terminationData);
    },
    deleteAssistedLivingCoaching(coachingId: number) {
        return client.delete(`${serviceURL}/delete/${coachingId}`);
    },
    getCalculatedUnits(id: number) {
        return client.get(`${serviceURL}/calculated-units/${id}`);
    },
}

export default assistedLivingCoachingService;